import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) }, 
  
  { path: 'pip', loadChildren: () => import('./pip/pip.module').then(m => m.PipModule) },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'usuario', loadChildren: () => import('./usuario/usuario.module').then(m => m.UsuarioModule) },
  { path: 'loader', loadChildren: () => import('./loader/loader.module').then(m => m.LoaderModule) },
  { path: 'servicio-tecnico', loadChildren: () => import('./servicio-tecnico/servicio-tecnico.module').then(m => m.ServicioTecnicoModule) },

  { path: 'sucursales', loadChildren: () => import('./sucursales/sucursales.module').then(m => m.SucursalesModule) },
  { path: ':categoria/:modelo', loadChildren: () => import('./pip/pip.module').then(m => m.PipModule) },
  { path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule) },
  { path: 'ecommerce/formas-de-pago', loadChildren: () => import('./ecommerce/formas-de-pago/formas-de-pago.module').then(m => m.FormasDePagoModule) },
  { path: 'ecommerce/catalogo', loadChildren: () => import('./ecommerce/catalogo/catalogo.module').then(m => m.CatalogoModule) },
  { path: 'ecommerce/repuesto', loadChildren: () => import('./ecommerce/repuesto/repuesto.module').then(m => m.RepuestoModule) },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
